import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toFieldErrors, type FieldErrors } from '@/shared/api/submit';

/** Save mutation with server-side field errors (`errors: { field: [msg] }`); `setErrors` lets forms add client-side ones. */
export function useSaveForm<Vars, Result>(
  mutationFn: (vars: Vars) => Promise<Result>,
  onSuccess: (result: Result) => void,
) {
  const [errors, setErrors] = useState<FieldErrors>({});

  const mutation = useMutation({
    mutationFn,
    onMutate: () => setErrors({}),
    onSuccess,
    onError: (error) => setErrors(toFieldErrors(error)),
  });

  const clearErrors = (...fields: string[]) =>
    setErrors((prev) => {
      const next = { ...prev };
      [...fields, 'server', 'common'].forEach((field) => delete next[field]);
      return next;
    });

  return { errors, setErrors, clearErrors, save: mutation.mutate, isPending: mutation.isPending };
}
